var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"form-row"},[_c('label',[_vm._v("Location")]),_c('location-typeahead',{staticClass:"typeahead",class:{ error: _vm.highlightRequiredComponentFields.indexOf('timeZoneId') !== -1},attrs:{"data-test":"timezone-typeahead","type":"timezone","value":_vm.value},on:{"input":_vm.getTimezone}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }